/**
 * Created by Kotkin on 28.05.17.
 */
import module from './interactive-fly-component';

export default module;
